export const validateNotWhitespaceOnly = value => !!value.trim() || 'Must include characters other than spaces';

export const isNullOrUndefined = value => value === null || value === undefined;
